
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars/ev-overview",
      function () {
        return require("private-next-pages/cars/ev-overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cars/ev-overview"])
      });
    }
  